<template>
    <div>
        <config-main-title>
            Cor para Tempo de Espera
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div
                    class="btn-group mb-1"
                    role="group"
                    aria-label="Basic example"
                >
                    <button
                        type="button"
                        class="btn"
                        :class="
                            viewMode == 'A'
                                ? 'btn-secondary'
                                : 'btn-outline-secondary'
                        "
                        @click="viewMode = 'A'"
                    >
                        Ativos
                    </button>
                    <button
                        type="button"
                        class="btn"
                        :class="
                            viewMode == 'T'
                                ? 'btn-secondary'
                                : 'btn-outline-secondary'
                        "
                        @click="viewMode = 'T'"
                    >
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="incluir()">
                    Incluir
                </button>
            </div>
        </div>

        <div v-if="dados && lista.length">
            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li
                    class="list-group-item"
                    v-for="(dado, id) in lista"
                    :key="id"
                >
                    <div class="d-flex justify-content-between">
                        <span class="h5 card-link mb-0 mr-3">
                            <a href="#" @click.prevent="editar(dado)">
                                {{ dado.search }}
                            </a>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="'categoria-' + id"
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)"
                                />
                                <label
                                    class="custom-control-label"
                                    :for="'categoria-' + id"
                                ></label>
                            </div>
                            <div v-else>
                                <span class="badge" :class="'badge-' + dado.st_cor">
                                    &lt; {{ dado.in_espera_ate_minutos }} min
                                </span>
                            </div>
                        </span>
                    </div>
                </li>
            </div>

            <pre v-if="1 == 0">{{ dados }}</pre>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhuma cor registrada." />
        </div>

        <!-- Modal -->
        <div
            class="modal fade"
            id="tempoCorModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Cor para Tempo de Espera</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Título"
                                    required
                                    :validate="validate"
                                    v-model="item.st_titulo"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Até (minutos)"
                                    required
                                    :validate="validate"
                                    v-model="item.in_espera_ate_minutos"
                                />
                            </div>
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    required
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'light', search: 'Branco' },
                                        { id: 'info', search: 'Ciano' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'success', search: 'Verde' },
                                        { id: 'danger', search: 'Vermelho' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_cor" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!-- <az-audit-log-button v-if="item.id_tipo_arquico" model="tipo_arquivo" :id="item.id_tipo_arquico" /> -->
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <az-submit @click="atualizar()">{{
                            item.id_tempo_espera_cor ? "Atualizar" : "Incluir"
                        }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
// import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A"
        };
    },

    computed: {
        lista: function() {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(" ", ".*");
            let match = parts;
            let reg = new RegExp(match, "i");

            return this.dados.filter(item => {
                return (
                    (item.fl_ativo || this.viewMode == "T") &&
                    (!this.search || reg.test(JSON.stringify(item)))
                );
            });
        }
    },

    components: {
        ConfigMainTitle,
        AzEmptyState,
        AzInput,
        AzSubmit
    },

    methods: {
        atualizar() {
            this.$util.atualizar(this, {
                service: "tempo_cores",
                dados: this.item,
                modal: "tempoCorModal",
                reload: true
            });
        },

        editar(item) {
            this.item = null;

            this.$nextTick(() => {
                this.item = _.cloneDeep(item);

                $("#tempoCorModal").modal("show");
            });
        },

        toggle(item) {
            this.$util.toggle(this, {
                service: "tempo_cores",
                dados: item
            });
        },

        incluir() {
            this.item = null;
            (this.validate = false),
                this.$nextTick(() => {
                    this.item = {
                        st_titulo: "",
                        st_cor: "",
                        in_espera_ate_minutos: 0, 
                        fl_ativo: true 
                    };
                    $("#tempoCorModal").modal("show");
                });
        },

        load() {
            this.$util.load(this, {
                service: "tempo_cores",
                parms: {
                    cadastro: true
                }
            });
        }
    },

    mounted() {
        this.load();

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Cor para Tempo de Espera", path: "" }
        ];

        this.$store.commit("setBreadcrumb", this.breadcrumb);
    }
};
</script>
